import { IFormValues } from "../form-modal/form-modal.types";
import { FormModal } from "../form-modal/form-modal.component";

import { NewExecutionBriefForm } from "./components/new-execution-brief-form/new-execution-brief-form.component";
import { NewExecutionBriefModalProps } from "./new-execution-brief-modal.props";
import { validation } from "./components/new-execution-brief-form/new-execution-brief-form.validation";

export const NewExecutionBriefModal = (props: NewExecutionBriefModalProps) => {
  const handleSubmit = (data: IFormValues) => {
    props.onSubmit({
      ...data,
      campaignBrief: props.campaignId,
      resourcetype: data.resourcetype.value,
    });
  };

  return (
    <FormModal
      Form={NewExecutionBriefForm}
      defaultValues={{ name: "", resourcetype: null }}
      formValidation={validation}
      isOpen={props.isOpen}
      modalErrors={props.errors}
      modalTitle={`Add Multi Channel Brief to ${props.campaignName}`}
      onClose={props.onClose}
      submit={handleSubmit}
    />
  );
};
